import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import styles from './DirectoryAZ.module.css';
import Header from './components/Header';
import Footer from './components/Footer';

const DirectoryAZ = () => {
  const [categories, setCategories] = useState([]);
  const [groupedCategories, setGroupedCategories] = useState({});
  const [sortedLetters, setSortedLetters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/directory/categories`);
        setCategories(response.data);
        groupCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const groupCategories = (data) => {
    const groups = data.reduce((acc, cat) => {
      const letter = cat.name.charAt(0).toUpperCase();
      if (!acc[letter]) {
        acc[letter] = [];
      }
      acc[letter].push(cat);
      return acc;
    }, {});

    setGroupedCategories(groups);
    setSortedLetters(Object.keys(groups).sort());
  };

  const scrollToLetter = (letter) => {
    const element = document.getElementById(`letter-${letter}`);
    if (element) {
      // Offset for sticky header
      const yOffset = -80; 
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }
  };

  return (
    <>
      <Header />
      <div className={styles.directoryContainer}>
        
        <div className={styles.header}>
            <h1>A-Z Business Directory</h1>
            <p>Browse all professionals and trades by category.</p>
        </div>

        {/* Quick Jump Bar */}
        <div className={styles.stickyNav}>
          <div className={styles.alphaBar}>
            {sortedLetters.map(letter => (
              <button 
                key={letter} 
                onClick={() => scrollToLetter(letter)}
                className={styles.alphaLink}
              >
                {letter}
              </button>
            ))}
          </div>
        </div>

        {/* Content Grid */}
        <div className={styles.gridContainer}>
          {loading ? (
            <p style={{textAlign: 'center', gridColumn: '1/-1'}}>Loading directory...</p>
          ) : (
            sortedLetters.map(letter => (
              <div key={letter} id={`letter-${letter}`} className={styles.letterGroup}>
                <h2 className={styles.letterTitle}>{letter}</h2>
                <ul className={styles.categoryList}>
                  {groupedCategories[letter].map(cat => (
                    <li key={cat.id}>
                      <Link to={`/directory/${cat.slug}`}>{cat.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DirectoryAZ;
